/**
 * Shared "received since" filter floor.
 *
 * Both the Tasks page (lender lane, shipped for ticket #388) and the Post
 * Tasks page use this same ISO date as the default `receivedFrom` value
 * sent to `/ui/tasks/list`, so it's defined once here rather than
 * duplicated as a literal in each page.
 */
export const RECEIVED_FROM_1_JULY_2026 = '2026-07-01';
